<template>
  <div class="license_box">
    <table class="table table-bordered">
      <tbody>
        <template v-for="(item, index) in items">
          <tr>
            <td><label>{{locale=='zh'?item.chVarName:item.enVarName}}</label></td>
          </tr>
          <tr>
            <td>{{item.Item_Value}}</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'NmsLicense',
  data() {
    return {
      locale: 'zh',
      items: []
    }
  },
  methods: {
    findNmsLicense() {
      const url = '/lte/ems/license/findNMSLicense';
      let That = this;
      this.$axios.get(url, {}).then(response => {
        let json = response.data.JsonStr;
        let lic = JSON.parse(json);
        That.items = lic.lic.ne.Item;
      })
    }
  },
  mounted() {
    this.locale = localStorage.getItem("locale");
    this.findNmsLicense();
  }
}
</script>
<style scoped>
  .license_box{
    width: 70%;
    margin: 10px 15%;
  }
</style>
